import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input() currentPage: any;
  @Input() totalItems: any;
  @Input() pageSize: any;
  @Input() pageSizeOptions: number[] = [3,6, 9, 12, 15];
  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() onPagesizechange: EventEmitter<number> = new EventEmitter();
  
 // pageSizeOptions: number[] = [3,6, 9, 12, 15];

  totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  onPageClick(page: number): void {
    this.pageChange.emit(page);
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.onPageClick(this.currentPage - 1);
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages()) {
      this.onPageClick(this.currentPage + 1);
    }
  }
  onPageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
    this.currentPage = 1; // Reset to first page when changing page size
    this.onPagesizechange.emit(pageSize)
    this.pageChange.emit(1); // Emit page change event with first page number
  }

}
